import { plainToClass } from "class-transformer";
import {
  IsDefined,
  ArrayMinSize,
  ArrayMaxSize,
  IsNumber,
  validateSync,
} from "class-validator";

export type CoordinatesPair = [number, number];

class CoordinatesPairValidationWrapper {
  @IsDefined()
  @IsNumber(undefined, { each: true })
  @ArrayMinSize(2)
  @ArrayMaxSize(2)
  public coordinates: CoordinatesPair;
}

export const isCoordinatePairValid = (coordinates: CoordinatesPair) => {
  const coordinatesTupleValidationWrapper = plainToClass(
    CoordinatesPairValidationWrapper,
    { coordinates: coordinates }
  );
  const validationResult = validateSync(coordinatesTupleValidationWrapper);
  return validationResult.length === 0;
};
